import styled from "styled-components";

const ExamsContainer = styled.div``;

export { ExamsContainer };
